import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import RenderComponent from '../components/renderComponent';

function StagesSubpage({lang}) {
    const { slug } = useParams();
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [title, setTitle] = useState(null)
    const [meta, setMeta] = useState({ title: '', description: '' });

    useEffect(() => {
        const fetchPage = async () => {
            setLoading(true);
            setError(null);
            
            try {
                const res = await fetch("/api/get-content", {
                    method: "GET",
                    headers: {
                        "ContentType": "pageStagesSubpage",
                        "Lang": lang,
                        "Slug": slug
                    },
                });
                const result = await res.json();

                if (result.data) {
                    setPageData(result.data);
                    setMeta({
                        title: result?.data?.metaTitle || slug + " | Eyeline",
                        description: result?.data?.metaDescription || 'Eyeline Studios ' + slug,
                    });
                } else {
                    setPageData(null);
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
            
        };

        fetchPage();
    }, [lang, slug]);

    useEffect(() => {
        if (meta.title) {
            document.title = meta.title;
        }

        if (meta.description) {
        let descTag = document.querySelector('meta[name="description"]');

        if (!descTag) {
            descTag = document.createElement('meta');
            descTag.setAttribute('name', 'description');
            document.head.appendChild(descTag);
        }

        descTag.setAttribute('content', meta.description);
        }
    }, [meta]);

    if (pageData)

    return <RenderComponent sections={pageData.pageSections} />;
}

export default StagesSubpage;